import config from '../config'
import { authorizedFetch }  from '../utils/auth.js'
import { checkStatus } from '../utils/fetch'
import { logOut } from '../actions/users'

export const SHOW_AVAILABLE_TIME_SLOT_FORM = 'SHOW_AVAILABLE_TIME_SLOT_FORM'
export const CLOSE_ADD_AVAILABLE_TIME_SLOT_FORM = 'CLOSE_ADD_AVAILABLE_TIME_SLOT_FORM'
export const UPDATE_AVAILABLE_TIME_SLOT_FIELD = 'UPDATE_AVAILABLE_TIME_SLOT_FIELD'
export const UPDATE_AVAILABLE_TIME_SLOT = 'UPDATE_AVAILABLE_TIME_SLOT'
export const UPDATE_AVAILABLE_TIME_SLOT_SUCCEDED = 'UPDATE_AVAILABLE_TIME_SLOT_SUCCEDED'
export const DELETE_AVAILABLE_TIME_SLOT = 'DELETE_AVAILABLE_TIME_SLOT'
export const DELETE_AVAILABLE_TIME_SLOT_SUCCEDED = 'DELETE_AVAILABLE_TIME_SLOT_SUCCEDED'
export const UPDATE_LAST_TIME = 'UPDATE_LAST_TIME'

export const showUpdateAvailableTimeSlotForm = (availableTimeSlot) => ({
  type: SHOW_AVAILABLE_TIME_SLOT_FORM,
  availableTimeSlot: availableTimeSlot
})

export const closeAddAvailableTimeSlotForm = () => ({
  type: CLOSE_ADD_AVAILABLE_TIME_SLOT_FORM,
})

export const updateAvailableTimeSlotField = (name, value) => ({
  type: UPDATE_AVAILABLE_TIME_SLOT_FIELD,
  name: name,
  value: value,
 
})

export const updateAvailableTimeSlot = (availableTimeSlot) => dispatch => {

  var headers = new Headers()
  headers.append('Content-Type', 'application/json');
  headers.append('Access-Control-Allow-Origin', '*');
  headers.append('Accept', 'application/json');

  authorizedFetch(config.api_url + 'locations/availableTimeSlot/update',
    {
      headers: headers,
      mode: 'cors',
      cache: 'default',
      method: "POST",
      body: JSON.stringify({availableTimeSlot: availableTimeSlot})
    })
    .then(checkStatus)
    .then(response => response.json())
    .then(json => dispatch(updateAvailableTimeSlotSucceded(json)))
    .catch(function(error) {
      dispatch(logOut())
    });
}

export const updateAvailableTimeSlotSucceded = (location) => ({
  type: UPDATE_AVAILABLE_TIME_SLOT_SUCCEDED,
  location: location
})

export const deleteAvailableTimeSlot = (availableTimeSlot) => dispatch => {

  var headers = new Headers()
  headers.append('Content-Type', 'application/json');
  headers.append('Access-Control-Allow-Origin', '*');
  headers.append('Accept', 'application/json');

  authorizedFetch(config.api_url + 'locations/availableTimeSlot/delete',
    {
      headers: headers,
      mode: 'cors',
      cache: 'default',
      method: "POST",
      body: JSON.stringify({ availableTimeSlot : availableTimeSlot })
    })
    .then(checkStatus)
    .then(response => response.json())
    .then(json => dispatch(deleteAvailableTimeSlotSucceded(json)))
    .catch(function(error) {
      dispatch(logOut())
    });
}

export const deleteAvailableTimeSlotSucceded = (location) => ({
  type: DELETE_AVAILABLE_TIME_SLOT_SUCCEDED,
  location: location
})

export const updateLastTime = (lastStartDate, lastEndDate) => ({
  type:UPDATE_LAST_TIME,
  lastStartDate,
  lastEndDate
})


// WEBPACK FOOTER //
// ./src/actions/availableTimeSlots.js